module.exports = __webpack_public_path__ + "static/ZenithSlabDJRColorSVG-Regular-57e2d22395bd8035798b46acaeafcf95.woff2";